import React, { useState } from "react";
import classes from "./ResultColumn.module.css";
import SwitchToggleFourOption from "../../../../../../UI/SwitchToggleFourOption";
import { SwitchToggleFourOptionEnum } from "../../../../../../../models/SwitchToggleFourOptionEnum";
import { useEffect } from "react";
import { SourceTypeEnum } from "../../../../../../../models/SourceTypeEnum";

const ResultColumn = ({ autoScore, success, handleCheckStatus, currentAssessment }) => {

    const [status, setStatus] = useState()

    const HandleStatus = () => {
        if (SourceTypeEnum[currentAssessment?.sourceType] === SourceTypeEnum.StorylineQuestionnaire && currentAssessment?.maxScore === 0) {
            setStatus(SwitchToggleFourOptionEnum.Disabled)
        }
        else {
            switch (success) {
                case true:
                    setStatus(SwitchToggleFourOptionEnum.Correct)
                    break;
                case false:
                    setStatus(SwitchToggleFourOptionEnum.InCorrect)
                    break;
                case null:
                    setStatus(SwitchToggleFourOptionEnum.NotChecked)
                    break;
                case undefined:
                    setStatus(SwitchToggleFourOptionEnum.Disabled)
            }
        }
    }

    useEffect(() => {
        HandleStatus()
    }, [currentAssessment])

    return <div className={classes.CorrectAnswerContainer}>
        {autoScore ?
            <div className={`${classes.CorrectAnswer} ${SourceTypeEnum[currentAssessment?.sourceType] === SourceTypeEnum.StorylineQuestionnaire && currentAssessment?.maxScore === 0 ? classes.NoSolution : success == true ? classes.Correct : success == false ? classes.InCorrect : classes.NoSolution} `}></div>
            : <SwitchToggleFourOption status={status} onChangeStatus={handleCheckStatus} ></SwitchToggleFourOption>}

    </div>
}
export default ResultColumn